import './App.css';
import { Switch, Route, Redirect } from 'react-router-dom'
import WithDrawer from './hoc/with-drawer/with-drawer.hoc';
import Landing from './pages/landing/landing.page';
import Home from './pages/home/home.page';
import Map from './pages/map/map.page';
import Viewer from './pages/viewer/viewer.page';
// import Viewer from './pages/viewer/viewer04.page'

function App() {
  return (
    <Switch>
      <Route exact path="/" component={() => <Redirect to="/landing" />} />
      <Route path="/landing" component={WithDrawer(Landing)} />
      <Route path="/home" component={WithDrawer(Home)} />
      <Route path="/map" component={WithDrawer(Map)} />
      <Route path="/viewer" component={WithDrawer(Viewer)} />
    </Switch>
  );
}

export default App;
